export const FETCH_RESOURCES = "resources/fetch";
export const DELETE_RESOURCES = "resources/delete";
export const ADD_RESOURCES = "resources/add";
